import axios from 'axios';
import { API_URL } from '../config/environment';

const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('ca_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      const hadToken = !!localStorage.getItem('ca_token');
      localStorage.removeItem('ca_token');
      localStorage.removeItem('ca_user');
      
      // Prevent repeated 401 noise by redirecting to login if token was expired
      if (hadToken && window.location.pathname.startsWith('/admin') && !window.location.pathname.includes('/login')) {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(err);
  }
);

export default api;
